"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CountryInfo = /*#__PURE__*/function (_Component) {
  _inherits(CountryInfo, _Component);

  function CountryInfo() {
    _classCallCheck(this, CountryInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(CountryInfo).apply(this, arguments));
  }

  _createClass(CountryInfo, [{
    key: "render",
    value: function render() {
      var country = this.props.country;
      return _react["default"].createElement("div", {
        className: "main"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "customers-info"
      }, _react["default"].createElement("div", {
        className: "customer-details"
      }, _react["default"].createElement("div", null, _react["default"].createElement("h2", {
        className: "customer-name"
      }, _react["default"].createElement("span", {
        className: "company"
      }, country.name))), _react["default"].createElement("div", null)), _react["default"].createElement("div", {
        className: "customers-main"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("div", {
        className: "personal-info padded"
      }, _react["default"].createElement("ul", null, _react["default"].createElement("li", {
        style: {
          borderBottom: '1px solid white'
        }
      }, _react["default"].createElement("h3", null, _react["default"].createElement("i", {
        className: "fa fa-fw fa-info"
      }), " Country info")), _react["default"].createElement("li", null, _react["default"].createElement("h3", null, _react["default"].createElement("i", {
        className: "fa fa-fw fa-globe"
      }), " Country id: ", country.id)), _react["default"].createElement("li", null, _react["default"].createElement("h3", null, _react["default"].createElement("i", {
        className: "fa fa-fw fa-globe"
      }), " Country iso: ", country.iso)))))))));
    }
  }]);

  return CountryInfo;
}(_react.Component);

exports["default"] = CountryInfo;